import React from 'react'

interface Props {
  children: React.ReactNode
}

interface State {
  failed: boolean
}

// An unexpected chart/rendering issue must never blank the whole user
// administration screen, including when a disabled account has no activity.
export default class ActivityErrorBoundary extends React.Component<Props, State> {
  state: State = { failed: false }

  static getDerivedStateFromError(): State {
    return { failed: true }
  }

  componentDidCatch(error: Error): void {
    console.error('User activity view failed to render', error)
  }

  render(): React.ReactNode {
    if (this.state.failed) {
      return (
        <div role="alert" className="mt-4 rounded-xl border border-amber-200 bg-amber-50 p-4 text-sm text-amber-900">
          Aktiivisuustietojen näyttäminen epäonnistui. Käyttäjätilien muut toiminnot ovat edelleen käytettävissä.
        </div>
      )
    }

    return this.props.children
  }
}
